import Vue from 'vue'

import SdMapTd from './SdMapTd'
import OverlayTdt from './OverlayTdt'

const components = {
  SdMapTd,
  OverlayTdt
}

for (const [key, value] of Object.entries(components)) {
  Vue.use({
    install: function (Vue) {
      Vue.component(key, value)
    },
  })
}